import moment from 'moment'

export const formatVideoLength = (length: number) => {
  const duration = moment.duration(length, 'seconds')
  const hours = Math.floor(duration.asHours())
  const minutes = Math.floor(duration.asMinutes()) - hours * 60

  if (!hours) {
    return `${minutes} min`
  }

  return `${hours} hr ${minutes} min`
}
